module.exports = __webpack_public_path__ + "img/orgFormal.4c51aa1e.png";